import React, { useState, useEffect, useMemo } from "react";
import { getCartItems, getprice } from "../../utils/cookieUtils";
import decodeTokenAndGetUserId from "../../utils/decodedToken";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";


const CheckoutOrders = () => {
  const location = useLocation();
  const totalPrice = location.state.totalPrice || 0;
  const token = localStorage.getItem("token");
  const userId = decodeTokenAndGetUserId(token);

  const navigate= useNavigate();

  const [orderData, setOrderData] = useState({
    product: getProducts(),
    price: totalPrice,
    username: "",
    email: "",
    address: "",
    userId: userId || "",
    phone: "",
  });

  const formFields = useMemo(() => {
    return userId
      ? ["product", "userId", "price"]
      : ["username", "email", "address", "product", "phone", "Quantity", "price"];
  }, [userId]);

  useEffect(() => {
    console.log("Request Body:", formFields);
  }, [formFields]);

  const handleFieldChange = (field, value) => {
    setOrderData((prevData) => ({ ...prevData, [field]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const response = await axiosInstance.post("api/products/placeorder", orderData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      const data = response.data;
  
      alert("Your order is completed!");
  
      const loggedToken = localStorage.getItem("token");
      if (!loggedToken) {
        const token = data.token;
        localStorage.setItem("token", token);
      }
      document.cookie = "cartItems=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

      navigate("/profile");
    } catch (error) {
      console.error("Error placing order:", error);
    }
  };
  

  return (
    <div className="w-full md:w-full">
      <div className="bg-gray-800 bg-opacity-75">
        <div className="bg-white p-6">
          <p className="text-lg font-semibold">Billing Details</p>
          <form className="flex flex-col md:flex-row justify-around">
            <div className="w-full md:w-1/3">
              {formFields.map((field) =>
                field === "product" || field === "userId" || field === "price" ? null : (
                  <FormField
                    key={field}
                    label={field}
                    value={orderData[field]}
                    onChange={(value) => handleFieldChange(field, value)}
                  />
                )
              )}
            </div>

            <div className="w-full md:w-1/3 pb-24 text-center">
              <OrderSummary totalPrice={totalPrice} />
              <PaymentOptions />
              <button
                onClick={handleFormSubmit}
                type="submit"
                className="bg-red-500 text-white py-2 px-4 rounded hover:bg-blue-600"
              >
                Place Order
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

const FormField = ({ label, value, onChange }) => (
  <div className="mb-4">
    <label htmlFor={label} className="block text-sm font-medium text-gray-600">
      {label}
    </label>
    <input
      type="text"
      name={label}
      id={label}
      placeholder={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="w-full p-2 border rounded-md"
    />
  </div>
);

const OrderSummary = ({ totalPrice }) => (
  <div className="p-10">
    <h2 className="text-2xl font-semibold">Your Total Orders</h2>
    <p className="text-red-500 text-2xl font-semibold">Total Price: NPR: {totalPrice}</p>
  </div>
);

const PaymentOptions = () => (
  <div>
    <button> Cash On Delivery</button>
    {/* Add other payment options as needed */}
  </div>
);

const getProducts = () => {
  const productMap = {};
  for (const cartItem of getCartItems()) {
    if (!productMap[cartItem.productId]) {
      productMap[cartItem.productId] = {
        productId: cartItem.productId,
        quantity: 0,
        cakeDetails: {},
      };
    }

    productMap[cartItem.productId].quantity += cartItem.quantity;

    if (cartItem.cakeDetails) {
      productMap[cartItem.productId].cakeDetails = {
        ...productMap[cartItem.productId].cakeDetails,
        ...cartItem.cakeDetails,
      };
    }
  }
  return Object.values(productMap);
};

export default CheckoutOrders;
